import { Namespaces } from 'redux/namespaces'

export const NotificationTypes = {
    ADD_NOTIFICATION: `${Namespaces.NOTIFICATION}_ADD_NOTIFICATION`,
    ADD_NOTIFICATIONS: `${Namespaces.NOTIFICATION}_ADD_NOTIFICATIONS`,
    REMOVE_NOTIFICATION: `${Namespaces.NOTIFICATION}_REMOVE_NOTIFICATION`,
    REMOVE_NOTIFICATIONS: `${Namespaces.NOTIFICATION}_REMOVE_NOTIFICATIONS`,
    REMOVE_ALL_NOTIFICATIONS: `${Namespaces.NOTIFICATION}_REMOVE_ALL_NOTIFICATIONS`,
}